import { Col, Form, DatePicker, Select } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import {
  GET_BUYER_ENDPOINT,
  STYLE_MERCHANDISING_LIST,
  ALL_SUB_STYLES,
} from "../../../apiServices/API_ENDPOINTS";
import { getData } from "../../../apiServices/common";
import CustomDatePicker from "common/CustomDatePicker";

const AssignmentFilterFields = ({ initialTableData, form }) => {
  const [buyerList, setBuyerList] = useState([]);
  const [styleList, setStyleList] = useState([]);
  const [subStyleList, setSubStyleList] = useState([]);

  // Others
  const { Option } = Select;

  useEffect(() => {
    getBuyerList();
    getStyleList();
    getSubStyleList();
  }, []);

  const saveToStorage = (value, name) => {
    const existingFilter =
      JSON.parse(localStorage.getItem("assignment_filter")) || {};
    existingFilter[name] = value;
    localStorage.setItem("assignment_filter", JSON.stringify(existingFilter));
  };

  const getBuyerList = async (filterValues) => {
    const query = `${GET_BUYER_ENDPOINT}`;
    const bodyData = {
      per_page: 10,
      name: filterValues?.name || "",
    };
    let res = await getData(query, false, bodyData);

    if (res) {
      setBuyerList(res?.data?.data?.data || []);
    }
  };

  const getStyleList = async (style_no) => {
    const bodyData = {
      style_no: style_no,
    };

    let res = await getData(STYLE_MERCHANDISING_LIST, false, bodyData);

    if (res) {
      setStyleList(res?.data?.data?.data || []);
    }
  };

  const getSubStyleList = async (sub_style_no, style_id) => {
    const bodyData = {
      sub_style_no: sub_style_no || "",
      style_id: style_id || "",
    };

    let res = await getData(ALL_SUB_STYLES, false, bodyData);

    if (res) {
      setSubStyleList(res?.data?.data?.data || []);
    }
  };

  return (
    <>
      <Col span={4}>
        <Form.Item label="Entry Date" name="assignment_date">
          <CustomDatePicker
            style={{ width: "100%" }}
            onChange={(value) =>
              saveToStorage(moment(value).format("YYYY-MM-DD"), "start")
            }
            size="small"
          />
          {/* <DatePicker
            style={{ width: "100%" }}
            onChange={(value) =>
              saveToStorage(moment(value).format("YYYY-MM-DD"), "start")
            }
            size="small"
          /> */}
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="Buyer" name="buyer_id">
          <Select
            showSearch
            placeholder="Select a Buyer"
            optionFilterProp="children"
            size="small"
            onSearch={(value) => getBuyerList({ name: value })}
            allowClear
            onClear={() => getBuyerList()}
          >
            {buyerList?.length &&
              buyerList.map((sup) => (
                <Option value={sup.id} key={sup.id}>
                  {sup.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="Style No." name="style_id">
          <Select
            showSearch
            placeholder="Select a Style No."
            optionFilterProp="children"
            onSearch={(value) => {
              getStyleList(value);
            }}
            onChange={(value) => {
              getSubStyleList("", value);
              form.setFieldsValue({ sub_style_id: undefined });
            }}
            size="small"
            allowClear
            onClear={() => {
              getStyleList();
              getSubStyleList();
            }}
          >
            {styleList &&
              styleList.map((sup) => (
                <Option value={sup.id} key={sup.id}>
                  {sup.style_no}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="Sub-Style No." name="sub_style_id">
          <Select
            showSearch
            placeholder="Select a Sub-Style"
            optionFilterProp="children"
            onSearch={(value) => {
              const selectedStyleId = form.getFieldValue("style_id");
              getSubStyleList(value, selectedStyleId);
            }}
            size="small"
            allowClear
            onClear={() => {
              const selectedStyleId = form.getFieldValue("style_id");
              getSubStyleList("", selectedStyleId);
            }}
          >
            {subStyleList &&
              subStyleList.map((sub) => (
                <Option value={sub.id} key={sub.id}>
                  {sub.sub_style_no}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
    </>
  );
};

export default AssignmentFilterFields;
